import http from '../../axios-config/g-http-metodos';

function getTransportadoras(pesquisa, empresaId, pedidoId) {
  const { res, erro, requisicao } = http.post(`Transportadora/GetTransportadora/${pesquisa}/${empresaId}/${pedidoId}`)
  return { TransportadoraArray: res, erro, requisicao }
}

function getTransportadorasByFiltro(objFiltro){
  const { res, erro, requisicao } = http.postArray("Transportadora/GetTransportadorasByFiltro", objFiltro)
  return { DocumentoComissoesArray: res, erro, requisicao }
}

function postTransportadora(TransportadoraViewModel){
  const { res, erro, requisicao } = http.postArray("Transportadora/PostTransportadora", TransportadoraViewModel)
  return { DocumentoComissoesArray: res, erro, requisicao }
}

function GetInfosFreteByTransportadoraId(pesquisa) {
  const { res, erro, requisicao } = http.post(`Transportadora/GetInfosFreteByTransportadoraId/${pesquisa}`)
  return { TransportadoraArray: res, erro, requisicao }
}

const TransportadoraController = {
  postTransportadora,
  getTransportadorasByFiltro,
  getTransportadoras,
  GetInfosFreteByTransportadoraId
}

export default TransportadoraController
